export default __webpack_public_path__ + "static/media/Snd_LowerQTurn.749c2e97.mp3";